import { render, staticRenderFns } from "./SSheetPrintPurchaseComp.vue?vue&type=template&id=312a4d62&"
import script from "./SSheetPrintPurchaseComp.vue?vue&type=script&lang=js&"
export * from "./SSheetPrintPurchaseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports